var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.6746V11.8202C19 11.3527 18.9996 11.1187 18.9427 10.9012C18.8924 10.7084 18.8097 10.5259 18.6977 10.3611C18.5715 10.175 18.3959 10.0207 18.044 9.71285L13.844 6.03785C13.1907 5.46622 12.8641 5.18056 12.4965 5.07184C12.1725 4.97605 11.8273 4.97605 11.5034 5.07184C11.136 5.18047 10.8099 5.46587 10.1576 6.03663L5.95618 9.71285C5.60431 10.0207 5.42879 10.175 5.30249 10.3611C5.19057 10.5259 5.10723 10.7084 5.05685 10.9012C5 11.1188 5 11.3526 5 11.8202V16.6746C5 17.49 5 17.8976 5.13321 18.2192C5.31083 18.648 5.65128 18.9891 6.08008 19.1667C6.40168 19.2999 6.80938 19.2999 7.62477 19.2999C8.44017 19.2999 8.84832 19.2999 9.16992 19.1667C9.59872 18.9891 9.93909 18.6481 10.1167 18.2193C10.2499 17.8977 10.25 17.49 10.25 16.6746V15.7996C10.25 14.8331 11.0335 14.0496 12 14.0496C12.9665 14.0496 13.75 14.8331 13.75 15.7996V16.6746C13.75 17.49 13.75 17.8977 13.8832 18.2193C14.0608 18.6481 14.4013 18.9891 14.8301 19.1667C15.1517 19.2999 15.5594 19.2999 16.3748 19.2999C17.1902 19.2999 17.5983 19.2999 17.9199 19.1667C18.3487 18.9891 18.6891 18.648 18.8667 18.2192C18.9999 17.8976 19 17.49 19 16.6746Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon);
export default __webpack_public_path__ + "static/media/main-icon.b3c3a06d3e48b4c0d9ad8687d68482bf.svg";
export { ForwardRef as ReactComponent };